// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Origens_CreateOrigemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/origens/createOrigem
 *
 * Returns the newly-created origem_id wrapped in an object.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Origens_CreateOrigemResponseDados {
origem_id: number
}

export type Origens_CreateOrigemResponse = ApiResponse<Origens_CreateOrigemResponseDados>;

registerResponseContract('Origens_CreateOrigemResponse', {
  origem_id: { type: 'number',  required: true },
})
